import { Inject, Injectable } from '@angular/core';
import { REG_HUB_COMMON_CONFIG, RegHubCommonConfig } from '../../reg-hub-common-config';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PhoneNumberValidationResult } from 'projects/reg-hub-common/src/public-api';

@Injectable({
  providedIn: 'root',
})
export class PhoneNumberValidationService {

  protected _baseLink: string;

  constructor(
    private http: HttpClient,
    @Inject(REG_HUB_COMMON_CONFIG) private config: RegHubCommonConfig) {
    this._baseLink = `${this.config.rootUrl}/Orders`;
  }

  public getPhoneValidationResults(orderID: string): Observable<PhoneNumberValidationResult> {
    return this.http.get<PhoneNumberValidationResult>(`${this._baseLink}/${orderID}/PhoneNumberValidationResults`);
  }

}
